var _style, _defs, _defs2, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 734 848.3",
    style: {
      enableBackground: "new 0 0 734 848.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000114061209192764297620000017322547588567648138_);}\r\n\t.st1{clip-path:url(#SVGID_00000160898445840646458070000006246919809016614058_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#B5394A;}\r\n\t.st4{fill:#B8850F;}\r\n\t.st5{fill:#0F2B47;}\r\n\t.st6{fill:#EA4F5F;}\r\n\t.st7{fill:#FAB31A;}\r\n\t.st8{fill:#004972;}\r\n\t.st9{fill:#008D89;}\r\n\t.st10{fill:#00ACA7;}\r\n\t.st11{clip-path:url(#SVGID_00000162336913059015642840000001277627784743729337_);}\r\n\t.st12{fill:#2B2A29;}\r\n\t.st13{fill:#B88724;}\r\n\t.st14{fill:#F9B329;}\r\n\t.st15{fill:#B64150;}\r\n\t.st16{fill:#EA5463;}\r\n\t.st17{fill:#25364E;}\r\n\t.st18{fill:#1C4F76;}\r\n\t.st19{fill:#0F8F8B;}\r\n\t.st20{fill:#14ADA8;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: -55.7,
    width: 734,
    height: 904
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096767436949445037100000010903443729786940813_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000096767436949445037100000010903443729786940813_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000033342045196779175110000003913441656311621026_",
    x: -305,
    y: -1.7,
    width: 1312,
    height: 859
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083059357704037945750000001135421570782368399_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000033342045196779175110000003913441656311621026_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000083059357704037945750000001135421570782368399_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M962.7,0.6h-1204v851.4h1204V0.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M271.5,676.4h229.1l114.2,176.1l-343.3,0V676.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.6,323l0.6,214.1l-377.5,152.7l28.7,162.7l349.5,0l-409.8,3l22.4-531L103.6,323z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M617.8,529.5V315.6l351.4-139.5l-0.2-165.6l20.1-0.1l17.9,519.1H617.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M617.8,857.2L500.4,676.2l117.4-112.1l344.5,0l0,293.1L617.8,857.2z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-273.4,689.8l377.5-152.7l132.7,139.3l0,176.1l-481.5,0L-273.4,689.8z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M969.3,176.1L617.8,315.6L491.6,176.1V0l477.5,0L969.3,176.1z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M456.9,176.1H216L104.7,0h352.3L456.9,176.1z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M103.6-1.7L216,176.1L103.5,288.3h-344.5V-0.8L103.6-1.7z"
  }))))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000160161309501855084980000011447892166910070430_",
    x: 200,
    y: 259.3,
    width: 320,
    height: 315
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039841648161646171100000015391774068973856443_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160161309501855084980000011447892166910070430_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039841648161646171100000015391774068973856443_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M418.9,452.7h0.3l12.7-20.8h12.4l-19,29.7v0.2l20.4,30.7h-12.4L418.6,470h-0.3l-14.6,22.5h-13.1l21.6-31.3 V461l-19.6-29.1H405L418.9,452.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M265,454.9V269.6l-65,65.1v120.2H265z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M210.4,324.3h103.9l0-65.1l-45.7,0L210.4,324.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M327,324.4l185.2,0l-65-65.1l-120.2,0L327,324.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M455,267.1l0,98.8h65l0-40.6L455,267.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M455,378.6v185.3l65-65.1l0-120.2H455z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M509.6,509.2l-101.3,0v65.1l43.1,0L509.6,509.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M395.5,509.2H210.4l65,65.1h120.1L395.5,509.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M265,563.9l0-96.2l-65,0v38L265,563.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M360,431.1c18.8,0,30.8,12.1,30.8,31.1c0,19.5-11.5,31.1-30.8,31.1c-18.6,0-30.4-12.4-30.4-31.1h11.8 c0,12.2,6.4,20.2,18.7,20.2c12.5,0,19.1-7.7,19.1-20.2c0-12.5-6.7-20.1-19.1-20.1L360,431.1L360,431.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M312.5,475c0-10.9-15.6-9.1-23.2-9.1v17.3C296.9,483.2,312.5,485.6,312.5,475L312.5,475z M305.2,455.3 c4.1-2.3,4.4-9.7,0.6-12.3c-3.6-2.5-11.9-1.8-16.6-1.8v16C294.5,457.1,300.7,457.8,305.2,455.3z M277.6,431.9 c8.5,0,23.9-1.1,31.5,1.2c7.4,2.2,10.4,6.7,10.4,14.3c0,8.1-4.9,12.6-12.7,13.6v0.4c8.5,0.4,18.1,4.4,18.1,14.2 c0,14.6-12.1,16.9-23.8,16.9h-23.5L277.6,431.9L277.6,431.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M408.1,361.8c0,2.1,0.9,3.8,2.7,5c1.8,1.2,4.1,2.2,6.9,3.1c2.8,0.9,5.7,1.7,8.9,2.5 c3.2,0.8,6.1,1.9,8.9,3.3c2.8,1.4,5.1,3.2,6.9,5.4c1.8,2.2,2.7,5.1,2.7,8.8c0,2.7-0.6,5.1-1.7,7.2c-1.2,2.2-2.8,4-4.9,5.6 c-2.1,1.6-4.6,2.8-7.5,3.6c-2.9,0.8-6.1,1.3-9.6,1.3c-3.8,0-7.3-0.4-10.4-1.3c-3.1-0.8-5.8-2.1-8-3.8c-2.2-1.7-3.9-3.9-5.1-6.5 c-1.2-2.6-1.8-5.7-1.8-9.3h11.8c0,3.5,1.2,6.3,3.5,8.3c2.3,2,5.6,3,9.8,3c3.6,0,6.6-0.7,8.9-2.2c2.3-1.5,3.5-3.4,3.5-5.9 c0-2.4-0.9-4.2-2.7-5.5c-1.8-1.3-4.1-2.4-6.8-3.3c-2.7-0.9-5.7-1.7-8.8-2.5c-3.2-0.8-6.1-1.8-8.8-3.1c-2.7-1.3-5-3-6.8-5.2 c-1.8-2.2-2.7-5.1-2.7-8.8L408.1,361.8L408.1,361.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M420,345.4c3.9,0,7.3,0.4,10.5,1.3c3.1,0.9,5.7,2.2,7.9,3.9c2.2,1.7,3.8,3.9,5,6.5c1.2,2.6,1.7,5.6,1.7,9 h-11.7c0-1.7-0.3-3.3-1-4.7c-0.7-1.4-1.6-2.6-2.7-3.6c-1.2-1-2.5-1.8-4.2-2.3c-1.6-0.5-3.4-0.8-5.4-0.8L420,345.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M336.2,346.2H381v11.3h-33v12.9h30.3v10.7H348v14.2h33v11.4h-44.8V346.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M289.5,386.3v20.5h-11.7v-30.7h22c3.8,0,6.7-0.9,8.6-2.6c2-1.8,2.9-4.2,2.9-7.4c0-3.2-0.9-5.6-2.7-7.2 c-1.8-1.6-4.8-2.4-8.9-2.4h-21.9v-10.2h23.9c4.1,0,7.5,0.5,10.3,1.5c2.8,1,5.1,2.4,6.8,4.2c1.7,1.8,3,3.8,3.7,6.2 c0.7,2.4,1.1,4.9,1.1,7.6c0,2.8-0.4,5.4-1.3,7.9c-0.8,2.5-2.1,4.7-3.9,6.6c-1.8,1.9-4,3.4-6.8,4.5c-2.8,1.1-6.1,1.6-10,1.6 L289.5,386.3L289.5,386.3z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/bg2.cbf7b7308a29665a2faf4b53a75c270b.svg";
export { ForwardRef as ReactComponent };